export default __webpack_public_path__ + "static/media/Cairo-Regular.cc12ed77.ttf";